import { render, staticRenderFns } from "./phoneChange.vue?vue&type=template&id=2496a6a0&scoped=true"
import script from "./phoneChange.vue?vue&type=script&lang=js"
export * from "./phoneChange.vue?vue&type=script&lang=js"
import style0 from "./phoneChange.vue?vue&type=style&index=0&id=2496a6a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496a6a0",
  null
  
)

export default component.exports